/*
	Сохраняем параметры сортировки и фильтрации акаунтов в localStorage
*/

export const setFilterParameters = (filter: string) => {
	localStorage.setItem("accountsFilter", filter);
};

export const getFilterParameters = () => {
	return localStorage.getItem("accountsFilter");
};
